export function addDays(days) {
    const today = new Date();
    const date = new Date(today);
    date.setDate(date.getDate() + days);
    return date.toISOString().slice(0, 10);
}
export const compareDatesGT = (start, end) => {
    const startDate = new Date(start).valueOf();
    const endDate = new Date(end).valueOf();
    return startDate > endDate;
};
export const compareTimeGT = (start, end) => {
    const start_time = start.split(':');
    const end_time = end.split(':');
    const first_time = new Date();
    const second_time = new Date();
    first_time.setHours(start_time[0], start_time[1]);
    second_time.setHours(end_time[0], end_time[1]);
    return first_time.getTime() > second_time.getTime();
};
export const compareTimeGTE = (start, end) => {
    const start_time = start.split(':');
    const end_time = end.split(':');
    const first_time = new Date();
    const second_time = new Date();
    first_time.setHours(start_time[0], start_time[1]);
    second_time.setHours(end_time[0], end_time[1]);
    return first_time.getTime() >= second_time.getTime();
};
export const dateFormat = (value) => {
    if (!value)
        return '';
    const date = new Date(value);
    const year = date.getFullYear();
    let month = '' + (date.getMonth() + 1);
    let day = '' + date.getDate();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
};
export const formatDateAsTimestamp = (value) => {
    const date = new Date(value);
    const options = {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
    };
    const formattedDate = date.toLocaleDateString('en-US', options);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedTime = `${formattedHours}:${minutes
        .toString()
        .padStart(2, '0')} ${period}`;
    const formattedDateTime = `${formattedDate} @ ${formattedTime}`;
    return formattedDateTime;
};
export const formatDateMMDDYY = (value) => {
    const date = new Date(value).toLocaleDateString([], {
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
    });
    return date;
};
export const formatDateMMDDYYYY = (value) => {
    const date = new Date(value).toLocaleDateString([], {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
    return date;
};
export const formatStringDate = (value) => {
    if (typeof value !== 'string') {
        return 'N/A';
    }
    const strDate = value.split('T')[0];
    if (!strDate) {
        return 'N/A';
    }
    const arrDate = strDate.split('-');
    if (arrDate.length !== 3) {
        return 'N/A';
    }
    return `${arrDate[1]}/${arrDate[2]}/${arrDate[0]}`;
};
export const getToday = () => {
    const date = new Date().toISOString().slice(0, 10);
    return date;
};
export const getTomorrow = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().slice(0, 10);
};
export const getYesterday = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().slice(0, 10);
};
export const timeFormat = (value) => {
    if (!value)
        return '';
    let [hours, mins] = value.split(':');
    if (parseInt(hours) > 12) {
        hours = parseInt(hours) - 12;
        if (hours < 10)
            hours = '0' + hours;
    }
    return hours + ':' + mins;
};
export const timeFormatMeridan = (value) => {
    try {
        if (!value)
            return '';
        let [hours, mins] = value.split(':');
        const meridan = parseInt(hours) > 12 ? 'PM' : 'AM';
        if (parseInt(hours) > 12) {
            hours = parseInt(hours) - 12;
            if (hours < 10)
                hours = '0' + hours;
        }
        return hours + ':' + mins + ' ' + meridan;
    }
    catch (error) {
        throw new Error('Invalid Value -> timeFormatMeridan');
    }
};
export const validateYear = (dateString) => {
    const inputYear = parseInt(dateString.slice(0, 4), 10);
    const currentYear = new Date().getFullYear();
    const minYear = 1900;
    const maxYear = currentYear + 15;
    if (isNaN(inputYear) || inputYear < minYear || inputYear > maxYear) {
        return false;
    }
    return true;
};
